import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/sincro-logo.png';
import { BuildingSelector } from './BuildingSelector.jsx';
import { NotificationBell } from './NotificationBell.jsx';
import { UserMenu } from './UserMenu.jsx';

/**
 * Top bar (64px, sticky). Hides BuildingSelector on:
 *   - /client/*    — the Client module is genuinely cross-building.
 *   - /analytics/* — Analytics owns its own 6-pill ScopeSelector
 *                    (ORD/LAX/YYZ/UK/DE/HR). HR isn't a building, so
 *                    the global selector doesn't fit.
 *
 * Admin pages stay scoped to a building (departments, shifts,
 * employees, lookup tables all key on building_id), so admins need
 * to switch buildings without leaving the area.
 */
export function AppHeader() {
  const location = useLocation();
  const pathname = location.pathname;
  const hideBuildingSelector =
    pathname.startsWith('/client') || pathname.startsWith('/analytics');

  return (
    <header className="sticky top-0 z-40 flex h-16 items-center gap-4 border-b border-sky-300 bg-white px-4 shadow-sm">
      <Link to="/" className="flex items-center gap-2" aria-label="Sincro Perfectmile home">
        <img src={logo} alt="Sincro" className="h-8" />
        <span className="hidden text-base font-semibold text-ink-900 md:inline">
          Perfectmile
        </span>
      </Link>

      {!hideBuildingSelector && <BuildingSelector />}

      <div className="ml-auto flex items-center gap-1">
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  );
}
